export default function parseJson<T extends anyObject>(json: string): T | null {
  try {
    return JSON.parse(json) as T;
  } catch (e) {
    console.debug('Error parse json', e);
  }
  return null;
};
